export default __webpack_public_path__ + "00835fc04d8ebf1b60d91de9f4e78cf4.woff2";